export default __webpack_public_path__ + "static/media/regulatory--yield--g1.00724e2e.png";